export default __webpack_public_path__ + "a6ec1c07f48115cc1f36b0aedb924403.png";